import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcess(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/finances/container_incomes/show_process/${agro_exporter_id}/fetch_agro_exporter_process/${agro_exporter_process_id}`
    );
  },
  fetchExportInvoice(agro_exporter_id, export_invoice_id) {
    return RequesterV1.get(
      `agro_exporter/finances/container_incomes/manage_invoice_payment/${agro_exporter_id}/fetch_export_invoice/${export_invoice_id}`
    );
  },
  fetchInvoicePayment(agro_exporter_id, invoice_payment_id) {
    return RequesterV1.get(
      `agro_exporter/finances/container_incomes/manage_invoice_payment/${agro_exporter_id}/fetch_invoice_payment/${invoice_payment_id}`
    );
  },
  create(agro_exporter_id, export_invoice_id, invoice_payment_params) {
    return RequesterV1.post(
      `agro_exporter/finances/container_incomes/manage_invoice_payment/${agro_exporter_id}/create/${export_invoice_id}`,
      { invoice_payment: invoice_payment_params }
    );
  },
  update(agro_exporter_id, invoice_payment_id, invoice_payment_params) {
    return RequesterV1.post(
      `agro_exporter/finances/container_incomes/manage_invoice_payment/${agro_exporter_id}/update/${invoice_payment_id}`,
      { invoice_payment: invoice_payment_params }
    );
  },
  destroy(agro_exporter_id, invoice_payment_id) {
    return RequesterV1.delete(
      `agro_exporter/finances/container_incomes/manage_invoice_payment/${agro_exporter_id}/destroy/${invoice_payment_id}`,
    );
  }
};
